import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth, API } from '../contexts/AuthContext';
import axios from 'axios';
import Swal from 'sweetalert2';
import CampanhaTracker from '../components/CampanhaTracker';

export default function Campanhas() {
  const { temPermissao } = useAuth();
  const navigate = useNavigate();
  const [campanhas, setCampanhas] = useState([]);
  const [filtroStatus, setFiltroStatus] = useState('');
  const [loading, setLoading] = useState(true);
  const [filiais, setFiliais] = useState([]);
  const [trackerCampanha, setTrackerCampanha] = useState(null); // campanha do modal de fase

  const carregar = () => {
    const params = filtroStatus ? `?status=${filtroStatus}` : '';
    axios.get(`${API}/campanhas${params}`).then(res => setCampanhas(res.data)).catch(() => {}).finally(() => setLoading(false));
  };

  useEffect(carregar, [filtroStatus]);
  useEffect(() => {
    axios.get(`${API}/filiais`).then(res => setFiliais(res.data)).catch(() => setFiliais([]));
  }, []);

  const novaCampanha = async () => {
    const lbl = 'display:block;text-align:left;font-size:0.8rem;font-weight:600;margin:10px 2px 2px;color:#444';
    const inp = 'width:100%;box-sizing:border-box;padding:8px 10px;font-size:0.9rem;border:1px solid #ccc;border-radius:6px;margin:0';
    const filiaisChecks = filiais.map(f => `
      <label style="display:flex;align-items:center;gap:6px;font-size:0.82rem;padding:3px 0;cursor:pointer">
        <input type="checkbox" class="c-fil" value="${parseInt(f.codigo)}"> ${String(f.codigo).padStart(2, '0')} — ${f.nome}
      </label>`).join('');

    const { value: formValues } = await Swal.fire({
      title: 'Nova Campanha',
      width: 560,
      html: `
        <div style="text-align:left;padding:0 4px">
          <label style="${lbl}">Nome da campanha *</label>
          <input id="c-nome" style="${inp}" placeholder="Ex: ARRAIÁ DO CENTRÃO 2026">

          <div style="display:flex;gap:10px">
            <div style="flex:1"><label style="${lbl}">Início</label><input id="c-ini" type="date" style="${inp}"></div>
            <div style="flex:1"><label style="${lbl}">Fim</label><input id="c-fim" type="date" style="${inp}"></div>
          </div>

          <label style="${lbl}">Quais filiais participam?</label>
          <div style="display:flex;gap:14px;margin-top:2px">
            <label style="font-size:0.85rem;display:flex;align-items:center;gap:5px;cursor:pointer">
              <input type="radio" name="c-escopo" value="todas" checked> Todas as filiais
            </label>
            <label style="font-size:0.85rem;display:flex;align-items:center;gap:5px;cursor:pointer">
              <input type="radio" name="c-escopo" value="especificas"> Filiais específicas
            </label>
          </div>
          <div id="c-filiais-box" style="display:none;border:1px solid #eee;border-radius:6px;padding:8px 10px;margin-top:6px;max-height:160px;overflow:auto;background:#fafafa">
            ${filiaisChecks || '<span style="font-size:0.8rem;color:#888">Nenhuma filial cadastrada</span>'}
          </div>

          <label style="display:flex;align-items:center;gap:7px;font-size:0.85rem;margin-top:12px;cursor:pointer">
            <input type="checkbox" id="c-gerente" checked> Coletar preço sugerido dos gerentes
          </label>
          <label style="display:flex;align-items:center;gap:7px;font-size:0.85rem;margin-top:6px;cursor:pointer">
            <input type="checkbox" id="c-12x"> Tem preço parcelado (12x)
          </label>

          <label style="${lbl}">Precificação</label>
          <select id="c-prec" style="${inp}">
            <option value="padrao">Padrão — digita o Preço direto</option>
            <option value="prazo">A partir do preço a prazo (Preço = prazo − %)</option>
          </select>
          <div id="c-perc-box" style="display:none">
            <label style="${lbl}">% de desconto sobre o preço a prazo</label>
            <input id="c-perc" style="${inp}" inputmode="decimal" placeholder="Ex: 10">
          </div>

          <label style="${lbl}">Nº Orçamento <span style="font-weight:400;color:#888">(opcional — importa produtos)</span></label>
          <input id="c-orc" style="${inp}" placeholder="Ex: 2603839">
        </div>
      `,
      focusConfirm: false,
      showCancelButton: true,
      confirmButtonText: 'Criar',
      cancelButtonText: 'Cancelar',
      confirmButtonColor: '#6B2C5C',
      didOpen: () => {
        const percBox = document.getElementById('c-perc-box');
        document.getElementById('c-prec').addEventListener('change', e => {
          percBox.style.display = e.target.value === 'prazo' ? 'block' : 'none';
        });
        const box = document.getElementById('c-filiais-box');
        document.querySelectorAll('input[name="c-escopo"]').forEach(r =>
          r.addEventListener('change', () => {
            box.style.display = document.querySelector('input[name="c-escopo"]:checked')?.value === 'especificas' ? 'block' : 'none';
          })
        );
      },
      preConfirm: () => {
        const nome = document.getElementById('c-nome').value.trim();
        const ini = document.getElementById('c-ini').value || null;
        const fim = document.getElementById('c-fim').value || null;
        const escopo = document.querySelector('input[name="c-escopo"]:checked')?.value || 'todas';
        const filiaisSel = [...document.querySelectorAll('.c-fil:checked')].map(c => parseInt(c.value));

        if (!nome) { Swal.showValidationMessage('Informe o nome da campanha'); return false; }
        if (ini && fim && ini > fim) { Swal.showValidationMessage('A data de início não pode ser depois da data de fim'); return false; }
        if (escopo === 'especificas' && filiaisSel.length === 0) { Swal.showValidationMessage('Selecione ao menos uma filial'); return false; }
        const tipoPrec = document.getElementById('c-prec').value;
        const percRaw = document.getElementById('c-perc').value.trim().replace(',', '.');
        const perc = percRaw === '' ? NaN : parseFloat(percRaw);
        if (tipoPrec === 'prazo' && (!Number.isFinite(perc) || perc < 0 || perc >= 100)) { Swal.showValidationMessage('Informe o % sobre o preço a prazo (0 a 99,99)'); return false; }

        return {
          nome, data_inicio: ini, data_fim: fim, escopo,
          filiais: escopo === 'especificas' ? filiaisSel : [],
          coletar_sugestoes_gerente: document.getElementById('c-gerente').checked,
          tem_preco_12x: document.getElementById('c-12x').checked,
          tipo_precificacao: tipoPrec,
          perc_prazo: tipoPrec === 'prazo' ? Math.round(perc * 100) / 100 : null,
          orcamento_ref: document.getElementById('c-orc').value.trim() || null,
        };
      },
    });

    if (!formValues || !formValues.nome) return;

    try {
      const res = await axios.post(`${API}/campanhas`, formValues);
      const campanhaId = res.data.id;

      if (formValues.orcamento_ref) {
        try {
          const prods = await axios.get(`${API}/produtos/orcamento/${encodeURIComponent(formValues.orcamento_ref)}`);
          if (prods.data.length > 0) {
            const produtos = prods.data.map(r => ({
              codpro: r.codpro, descricao: r.descricao, classe: r.clasprod,
              classe_nome: r.classe_nome, disponibilidade: r.disponibilidade,
              custo: r.custo, preco_sistema: r.preco_venda
            }));
            const add = await axios.post(`${API}/produtos/campanha/${campanhaId}`, { produtos });
            Swal.fire({ icon: 'success', title: 'Campanha criada!', text: `${add.data.inseridos} produto(s) importados do orçamento ${formValues.orcamento_ref}`, timer: 2500, showConfirmButton: false });
          } else {
            Swal.fire({ icon: 'warning', title: 'Campanha criada', text: `Nenhum produto encontrado no orçamento ${formValues.orcamento_ref}`, timer: 2500, showConfirmButton: false });
          }
        } catch (errImport) {
          Swal.fire('Campanha criada, mas...', errImport.response?.data?.error || 'Erro ao importar produtos do orçamento', 'warning');
        }
      } else {
        Swal.fire({ icon: 'success', title: 'Campanha criada!', timer: 1500, showConfirmButton: false });
      }

      navigate(`/campanhas/${campanhaId}/produtos`);
    } catch (err) {
      Swal.fire('Erro', err.response?.data?.error || 'Erro ao criar campanha', 'error');
    }
  };

  const remover = async (id, nome) => {
    const r = await Swal.fire({ title: `Remover "${nome}"?`, text: 'Só campanhas em rascunho podem ser removidas', icon: 'warning', showCancelButton: true, confirmButtonText: 'Remover', cancelButtonText: 'Cancelar', confirmButtonColor: '#dc3545' });
    if (!r.isConfirmed) return;
    try {
      await axios.delete(`${API}/campanhas/${id}`);
      carregar();
    } catch (err) {
      Swal.fire('Erro', err.response?.data?.error || 'Erro ao remover', 'error');
    }
  };

  const editar = async (c) => {
    const lbl = 'display:block;text-align:left;font-size:0.8rem;font-weight:600;margin:10px 2px 2px;color:#444';
    const inp = 'width:100%;box-sizing:border-box;padding:8px 10px;font-size:0.9rem;border:1px solid #ccc;border-radius:6px;margin:0';
    const esc = (s) => String(s || '').replace(/"/g, '&quot;');
    const { value } = await Swal.fire({
      title: 'Editar campanha',
      html: `
        <div style="text-align:left;padding:0 4px">
          <label style="${lbl}">Nome *</label>
          <input id="e-nome" style="${inp}" value="${esc(c.nome)}">
          <div style="display:flex;gap:10px">
            <div style="flex:1"><label style="${lbl}">Início</label><input id="e-ini" type="date" style="${inp}" value="${c.data_inicio ? c.data_inicio.split('T')[0] : ''}"></div>
            <div style="flex:1"><label style="${lbl}">Fim</label><input id="e-fim" type="date" style="${inp}" value="${c.data_fim ? c.data_fim.split('T')[0] : ''}"></div>
          </div>
        </div>`,
      focusConfirm: false, showCancelButton: true, confirmButtonText: 'Salvar', cancelButtonText: 'Cancelar', confirmButtonColor: '#6B2C5C',
      preConfirm: () => {
        const nome = document.getElementById('e-nome').value.trim();
        const ini = document.getElementById('e-ini').value || null;
        const fim = document.getElementById('e-fim').value || null;
        if (!nome) { Swal.showValidationMessage('Informe o nome da campanha'); return false; }
        if (ini && fim && ini > fim) { Swal.showValidationMessage('A data de início não pode ser depois da de fim'); return false; }
        return { nome, data_inicio: ini, data_fim: fim };
      },
    });
    if (!value) return;
    try {
      await axios.put(`${API}/campanhas/${c.id}/info`, value);
      Swal.fire({ icon: 'success', title: 'Salvo!', timer: 1200, showConfirmButton: false });
      carregar();
    } catch (err) {
      Swal.fire('Erro', err.response?.data?.error || 'Erro ao salvar', 'error');
    }
  };

  const badgeClass = (status) => `badge-${status || 'rascunho'}`;

  if (loading) return <div className="text-center py-5"><div className="spinner-border" style={{ color: '#6B2C5C' }} /></div>;

  return (
    <div>
      <div className="d-flex justify-content-between align-items-center mb-4">
        <h4 className="fw-bold mb-0">Campanhas</h4>
        {temPermissao('campanhas_criar') && (
          <button className="btn-primary-mkt" onClick={novaCampanha}>
            <i className="bi bi-plus-lg me-1"></i> Nova Campanha
          </button>
        )}
      </div>

      <div className="card p-3 mb-3">
        <div className="d-flex gap-2 align-items-center">
          <label style={{ fontSize: '0.85rem', whiteSpace: 'nowrap' }}>Filtrar:</label>
          <select className="form-select form-select-sm" style={{ maxWidth: 200 }} value={filtroStatus} onChange={e => setFiltroStatus(e.target.value)}>
            <option value="">Todas</option>
            <option value="rascunho">Rascunho</option>
            <option value="preenchimento">Preenchimento</option>
            <option value="aprovacao">Aprovação</option>
            <option value="ativa">Ativa</option>
            <option value="encerrada">Encerrada</option>
          </select>
        </div>
      </div>

      <div className="card p-3">
        <div className="tabela-container">
          <table className="table table-mkt table-hover mb-0">
            <thead>
              <tr><th>Nome</th><th>Período</th><th>Produtos</th><th>Aprovados</th><th>Status</th><th>Criado por</th><th></th></tr>
            </thead>
            <tbody>
              {campanhas.map(c => (
                <tr key={c.id}>
                  <td className="fw-semibold" style={{ cursor: 'pointer' }} onClick={() => navigate(`/campanhas/${c.id}/produtos`)}>
                    {c.nome}
                    {!c.visivel_gerente && <i className="bi bi-eye-slash ms-2" style={{ color: '#999' }} title="Oculta pros gerentes de loja"></i>}
                  </td>
                  <td style={{ fontSize: '0.83rem' }}>
                    {c.data_inicio ? new Date(c.data_inicio).toLocaleDateString('pt-BR', { timeZone: 'UTC' }) : '—'}
                    {' → '}
                    {c.data_fim ? new Date(c.data_fim).toLocaleDateString('pt-BR', { timeZone: 'UTC' }) : '—'}
                  </td>
                  <td>{c.qtd_produtos || 0}</td>
                  <td>{c.qtd_aprovados || 0}</td>
                  <td>
                    <span className={badgeClass(c.status)}>{c.status}</span>
                    {c.erp_oferta_oid && <span className="ms-1 badge" style={{ backgroundColor: '#28a745', fontSize: '0.7rem' }}>ERP</span>}
                  </td>
                  <td style={{ fontSize: '0.83rem' }}>{c.criado_por_nome || '—'}</td>
                  <td>
                    <div className="d-flex gap-1">
                      <button className="btn btn-sm btn-outline-secondary" onClick={() => setTrackerCampanha(c)} title="Ver fase do processo" style={{ borderColor: '#6B2C5C', color: '#6B2C5C' }}>
                        <i className="bi bi-signpost-split"></i>
                      </button>
                      <button className="btn btn-sm btn-outline-secondary" onClick={() => navigate(`/campanhas/${c.id}/produtos`)} title="Gerenciar">
                        <i className="bi bi-pencil-square"></i>
                      </button>
                      {temPermissao('relatorio_comissao_extra') && (
                        <button className="btn btn-sm btn-outline-primary" onClick={() => navigate(`/campanhas/${c.id}/comissao-extra`)} title="Relatório Comissão Extra" style={{ borderColor: '#6B2C5C', color: '#6B2C5C' }}>
                          <i className="bi bi-cash-coin"></i>
                        </button>
                      )}
                      {c.status === 'rascunho' && temPermissao('campanhas_editar') && (
                        <button className="btn btn-sm btn-outline-secondary" onClick={() => editar(c)} title="Editar nome e datas">
                          <i className="bi bi-pencil"></i>
                        </button>
                      )}
                      {c.status === 'rascunho' && temPermissao('campanhas_criar') && (
                        <button className="btn btn-sm btn-outline-danger" onClick={() => remover(c.id, c.nome)} title="Remover">
                          <i className="bi bi-trash"></i>
                        </button>
                      )}
                    </div>
                  </td>
                </tr>
              ))}
              {campanhas.length === 0 && <tr><td colSpan="7" className="text-center text-muted">Nenhuma campanha encontrada</td></tr>}
            </tbody>
          </table>
        </div>
      </div>

      {trackerCampanha && (
        <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.5)', zIndex: 9999, display: 'flex', alignItems: 'center', justifyContent: 'center' }} onClick={() => setTrackerCampanha(null)}>
          <div className="card p-4" style={{ width: '90%', maxWidth: 520, maxHeight: '85vh', overflow: 'auto' }} onClick={e => e.stopPropagation()}>
            <div className="d-flex justify-content-between align-items-start mb-3">
              <div>
                <h6 className="fw-bold mb-1">Fase do processo</h6>
                <div style={{ fontSize: '0.85rem', color: '#666' }}>
                  {trackerCampanha.nome} <span className={`badge-${trackerCampanha.status || 'rascunho'} ms-1`}>{trackerCampanha.status}</span>
                </div>
              </div>
              <button className="btn btn-sm btn-outline-secondary" onClick={() => setTrackerCampanha(null)}><i className="bi bi-x-lg"></i></button>
            </div>
            <CampanhaTracker
              campanha={trackerCampanha}
              qtdProdutos={trackerCampanha.qtd_produtos || 0}
              qtdAprovados={trackerCampanha.qtd_aprovados || 0}
              variant="modal"
            />
            <div className="d-flex justify-content-end mt-3">
              <button className="btn-outline-mkt" onClick={() => { const cid = trackerCampanha.id; setTrackerCampanha(null); navigate(`/campanhas/${cid}/produtos`); }}>
                <i className="bi bi-box-arrow-up-right me-1"></i>Abrir campanha
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
